// extracted by css-extract-rspack-plugin
module.exports =  {"recent-progress":"Show-nPDW__recent-progress","chapters-overview":"Show-GigU__chapters-overview","no-group-tile":"Show-kVVk__no-group-tile"};